(function(){
  document.querySelectorAll('[data-countdown]').forEach(function(el){
    var t=new Date(el.getAttribute('data-countdown')).getTime();if(isNaN(t))return;
    function tick(){var d=Math.max(0,t-Date.now());
      el.innerHTML=[['Days',864e5],['Hrs',36e5],['Min',6e4],['Sec',1e3]].map(function(p){var v=Math.floor(d/p[1]);d-=v*p[1];return '<div>'+String(v).padStart(2,'0')+'<small>'+p[0]+'</small></div>'}).join('')}
    tick();setInterval(tick,1000);
  });
  document.querySelectorAll('.qty').forEach(function(box){
    var input=box.querySelector('input'),tot=box.querySelector('[data-total]'),price=+box.dataset.price/100;
    box.querySelectorAll('[data-step]').forEach(function(b){b.addEventListener('click',function(){
      var v=Math.min(10,Math.max(1,(+input.value||1)+(+b.dataset.step)));input.value=v;
      try{tot.textContent=new Intl.NumberFormat(undefined,{style:'currency',currency:box.dataset.currency}).format(v*price)}catch(e){tot.textContent=(v*price).toFixed(2)}
    })});
  });
})();
